import Button from '2-core-elements/Buttons/Button';
import Image, { type ImageProps } from '2-core-elements/Image/Image';


export type PeopleCardProps = {
    img?: Pick<ImageProps, 'imgSrc' | 'imgAlt' | 'imgHeight' | 'imgWidth' | 'imgSrcSet'>;
    link?: { href: string; label?: string; target?: '_self' | '_blank' };
    title: string;
    subtitle?: string;
    children?: React.ReactNode;
};

const CardPerson = ({
    img,
    link = { href: '', label: 'Learn more', target: '_self' },
    title,
    subtitle,
    children,
}: PeopleCardProps): JSX.Element => {
    return (
        <a href={link.href} className={`people-card`}>
            {img && (
                <div className="card-img">
                    <Image aspectRatio="1/1" imgSrc={img.imgSrc} imgAlt={img.imgAlt} imgSrcSet={img.imgSrcSet} />
                </div>
            )}
            <div className="card-content">
                <h3 className="card-title">
                    {title}
                </h3>
                {subtitle && (
                    <p className="card-subtitle">{subtitle}</p>
                )}
                {children && (
                    <div className="card-description">
                        {children}
                    </div>
                )}
                {link?.label && (
                    <div className="card-cta">
                        <Button skin="2" size="sm" className="card-cta-btn" asDiv={true}>
                            {link.label}
                        </Button>
                    </div>
                )}
            </div>
        </a>
    );
};

export default CardPerson;
